import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '吃瓜分类',
      links: categories.map((cat) => ({
        name: cat.name,
        path: `/category/${cat.slug}`,
      })),
    },
    {
      title: '关于我们',
      links: [
        { name: '品牌介绍', path: '/about' },
        { name: '用户口碑', path: '/about#reputation' },
        { name: '联系我们', path: '/about#contact' },
        { name: '加入我们', path: '/about#join' },
      ],
    },
    {
      title: '友情链接',
      links: [
        { name: '吃瓜群APP', path: '/article/chiguaqun-app-zuixin-xiazai-dizhi' },
        { name: 'QQ吃瓜群', path: '/article/qq-chiguaqun-zuixin-rukou-2026' },
        { name: '吃瓜路线', path: '/category/chigua-luxian' },
        { name: '最新爆料', path: '/category/zuixin-baoliao' },
      ],
    },
  ];

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-5">
                <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-background-50 text-xl"></i>
                </div>
                <span className="font-heading text-2xl font-bold text-background-50">
                  吃瓜群
                </span>
              </Link>
              <p className="text-foreground-400 text-sm leading-relaxed max-w-sm mb-6">
                吃瓜群官网——专注吃瓜群众免费吃瓜与在线爆料内容聚合平台。实时更新网红博主塌房现场、明星大瓜及热门黑料事件，提供吃瓜群众路线与聚集地入口，让每一位吃瓜群众都能第一时间了解全网吃瓜动态。
              </p>
              <div className="flex items-center gap-3">
                {['ri-weibo-line', 'ri-wechat-line', 'ri-tiktok-line', 'ri-bilibili-line'].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-9 h-9 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-primary-500 hover:bg-primary-500 transition-all cursor-pointer"
                    aria-label={icon.replace('ri-', '').replace('-line', '')}
                    rel="nofollow"
                  >
                    <i className={`${icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 吃瓜群官网 chiguaqun.com 版权所有
            </p>
            <div className="flex items-center gap-5">
              <Link to="/about" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">
                隐私政策
              </Link>
              <Link to="/about" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">
                用户协议
              </Link>
              <Link to="/about#contact" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}